var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfileHelpSupport = function SvgProfileHelpSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0F172A",
    strokeWidth: 1.125,
    d: "M12.75 8.853c0-.259 0-.389.039-.504.113-.336.412-.466.712-.602.337-.154.505-.23.672-.244.189-.015.379.026.54.116.215.12.365.35.518.536.707.86 1.061 1.289 1.19 1.763.105.382.105.782 0 1.164-.188.691-.785 1.27-1.226 1.807-.226.274-.339.412-.482.492a.95.95 0 0 1-.54.116c-.167-.014-.335-.09-.672-.244-.3-.136-.599-.266-.712-.602-.039-.115-.039-.245-.039-.504zM5.25 8.853c0-.326-.01-.62-.273-.849-.096-.083-.223-.141-.478-.257-.336-.154-.505-.23-.672-.244-.5-.04-.77.301-1.058.652-.707.86-1.061 1.289-1.19 1.763a2.2 2.2 0 0 0 0 1.164c.188.692.785 1.27 1.226 1.807.278.338.544.647 1.022.608.167-.014.336-.09.672-.243.255-.117.382-.175.478-.258.264-.23.273-.523.273-.85z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0F172A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.125,
    d: "M15 7.875V6.75c0-2.9-2.686-5.25-6-5.25S3 3.85 3 6.75v1.125M15 13.125C15 16.5 12 16.5 9 16.5"
  })));
};
export default SvgProfileHelpSupport;